import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Input as NextUIInput } from "@nextui-org/react";
import { useField } from "formik";
import React from "react";
export var Input = function Input(props) {
  var _useField = useField(props),
      _useField2 = _slicedToArray(_useField, 2),
      field = _useField2[0],
      meta = _useField2[1];

  return /*#__PURE__*/React.createElement(NextUIInput, _extends({}, field, {
    status: meta.error ? "error" : "primary"
  }, props));
};
export var Password = function Password(props) {
  var _useField3 = useField(props),
      _useField4 = _slicedToArray(_useField3, 2),
      field = _useField4[0],
      meta = _useField4[1];

  return /*#__PURE__*/React.createElement(NextUIInput.Password, _extends({}, field, {
    status: meta.error ? "error" : "primary"
  }, props));
};
Input.Password = Password;
export var Textarea = function Textarea(props) {
  var _useField5 = useField(props),
      _useField6 = _slicedToArray(_useField5, 2),
      field = _useField6[0],
      meta = _useField6[1];

  return /*#__PURE__*/React.createElement(NextUIInput.Textarea, _extends({}, field, {
    status: meta.error ? "error" : "primary"
  }, props));
};
Input.Textarea = Textarea;